@if (service.loading) {
<div class="spinner-container">
  <mat-spinner></mat-spinner>
</div>
}

<div class="audit-header">
  <h2>International Protocol (IP) Request - My List</h2>
</div>

<ul class="two-cols">
  @for (item of IPArray; track item) {
  <li>{{ item.Name }}</li>
  }
</ul>
